import React, { Component } from "react";
import { Link } from "react-router-dom";
import Validate from "./FormValidation";

import { Auth, API, graphqlOperation } from "aws-amplify";
import { createCustomer } from "../graphql/mutations";
import * as googleMap from "react-google-maps";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import Autocomplete from "react-google-autocomplete";
import awsConfigSettings from "../aws-exports";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Label,
  FormFeedback,
  FormText
} from "reactstrap";
class TireVendorRegForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: null,
      firstName: null,
      lastName: null,
      email: null,
      password: null,
      cPassword: null,
      address: null,
      city: "",
      state: "",
      zipCode: "",
      phoneNo: null,
      passwordValidate: true,
      phoneValidated: true,
      lat: "",
      lng: "",

      errors: {
        cognito: null,
        blankfield: false,
        passwordmatch: false
      },
      emailValidate: true,
      emailFeadback: null,
      usernameValidate: true,
      usernameFeadback: null
    };
  }
  // static contextType = Context;
  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: null,
        blankfield: false,
        passwordmatch: false
      }
    });
  };
  checkValidate = () => {
    let { passwordValidate, phoneValidated } = this.state;
    if (!passwordValidate) {
      document.getElementById("password").focus();
      return false;
    } else if (!phoneValidated) {
      document.getElementById("phoneNum").focus();
      return false;
    } else {
      return true;
    }
  };
  handleSubmit = async event => {
    event.preventDefault();
    if (event.target.name === "submit") {
      let {
        firstName,
        lastName,
        username,
        email,
        password,
        cPassword,
        address,
        city,
        state,
        phoneNo,
        zipCode,
        passwordValidate,
        phoneValidated,
        emailValidate,
        lat,
        lng
      } = this.state;
      if (firstName === null || firstName === "")
        document.getElementById("fName").focus();
      else if (lastName === null || lastName === "")
        document.getElementById("lName").focus();
      else if (username === null || username === "")
        document.getElementById("username").focus();
      else if (!passwordValidate) document.getElementById("cPassword").focus();
      else if (!phoneValidated) document.getElementById("phoneNo").focus();
      else if (address === null || address === "")
        document.getElementById("address").focus();
      else if (city === null || city === "")
        document.getElementById("city").focus();
      else if (state === null || state === "")
        document.getElementById("state").focus();
      else if (zipCode === null || zipCode === "")
        document.getElementById("zipCode").focus();
      else if (!document.getElementById("cbRegister").checked)
        document.getElementById("cbRegister").focus();
      else if (lat === "" || lng === "") {
        document.getElementById("address").focus();
      } else {
        try {
          phoneNo = phoneNo.replace("(", "");
          phoneNo = phoneNo.replace(")", "");
          phoneNo = phoneNo.replace("-", "");
          phoneNo = phoneNo.replace(" ", "");
          phoneNo = "+1" + phoneNo;
          const signUpResponse = await Auth.signUp({
            username: username,
            password,
            attributes: {
              // email: email,
              phone_number: phoneNo
            }
          });

          const custAddress = {
            address,
            city,
            state: state,
            zipCode,
            locationLat: "",
            locationLong: ""
          };

          this.setState({ id: signUpResponse.userSub });
          localStorage.setItem("userInfo", JSON.stringify(this.state));
          this.props.history.push("/RegVendorConfirmation");
        } catch (err) {
          toast.error(err.message);
          if (err.code === "UsernameExistsException") {
            document.getElementById("username").focus();
            this.setState({
              usernameValidate: false,
              usernameFeadback: "Username already exist!"
            });
          }
          this.setState({
            errors: {
              ...this.state.errors,
              cognito: err
            }
          });
        }
      }
    }
  };
  onUsernameChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      usernameValidate: false,
      usernameFeadback: ""
    });
    //this.setState({  });
  };
  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });

    // document.getElementById(event.target.id).classList.remove("is danger");
  };
  onPasswordChange = (e, otherPassword) => {
    e.currentTarget.type = "password";
    this.setState({ [e.target.id]: e.target.value });
    if (e.target.value !== otherPassword)
      this.setState({ passwordValidate: false });
    else this.setState({ passwordValidate: true });
  };
  onEmailChange = e => {
    let { value } = e.target;
    value = value.toLowerCase();
    this.setState({ email: value });
    if (!/.+@.+\.[A-Za-z]+$/.test(value)) {
      this.setState({
        emailValidate: false,
        emailFeadback: "Email not in correct format"
      });
    } else
      this.setState({
        emailValidate: true,
        emailFeedback: ""
      });
  };
  checkUsernameAvailability = async e => {
    return;
    let { value } = e.target;
    if (value === "" || value === null) return;
    value = value.toLowerCase();
    this.setState({ username: value });
    /*
    try {
      const signUpResponse = await Auth.signUp({
        username: value,
        password: "12325",
        attributes: {
          email: "abc@test.com"
        }
      });
    } catch (err) {
      // toast.error(err.message);
      if (err.code === "UsernameExistsException")
        document.getElementById("username").focus();
      this.setState({
        usernameValidate: false,
        usernameFeadback: "Username already exist!"
      });
    }
    */

    let userExists = true;
    Auth.signIn({ username: value, password: "eeeeee" })
      .then(res => {
      })
      .catch(error => {
        const code = error.code;
        switch (code) {
          case "UserNotFoundException":
            //return !this.redirectToRegister(email);
            userExists = false;
            break;
          case "NotAuthorizedException":
            userExists = true;
            break;
          case "PasswordResetRequiredException":
            userExists = true;
            break; // !this.forgotPassword(email);
          case "UserNotConfirmedException":
            userExists = true;
            break; // !this.redirectToCompleteRegister(email);
          default:
            userExists = false;
            break;
        }
        if (error.code !== "UserNotFoundException")
          this.setState({
            usernameValidate: false,
            usernameFeadback: "Username already exist!"
          });
        else this.setState({ usernameValidate: true });
      });

    /*
    this.setState({ username: value, emailValidate: false, emailFeadback: "" });
    let check = await this.isUsernameExist(value);
    if (check) {
      this.setState({ usernameValidate: true });
    } else {
      this.setState({
        usernameValidate: false,
        usernameFeadback: "Username already exist! Pleas select another."
      });
    }
*/
    /*
    Auth.signIn({ username: value, password: "123" })
      .then(res => {
      })
      .catch(err => {
        if (err.code !== "NotAuthorizedException")
         
        else 
      });*/
  };
  async isUsernameExist(username) {
    const code = "025413";
    await Auth.confirmSignUp(username, code, {
      // If set to False, the API will throw an AliasExistsException error if the phone number/email used already exists as an alias with a different user
      forceAliasCreation: true
    })
      .then(() =>{}) 
      .catch(err => {
        switch (err.code) {
          case "UserNotFoundException":
            return true;
          case "NotAuthorizedException":
            return false;
          case "AliasExistsException":
            // Email alias already exists
            return false;
          case "CodeMismatchException":
            return false;
          case "ExpiredCodeException":
            return false;
          default:
            return false;
        }
      });
  }
  onPhoneChange = e => {
    let { id, value } = e.target;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (value.match(phoneno)) {
      this.setState({ [id]: value, phoneValidated: true });
    } else {
      this.setState({ [id]: value, phoneValidated: false });
    }
  };

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    let {
      passwordValidate,
      phoneValidated,
      emailValidate,
      usernameValidate
    } = this.state;
    return (
      <div>
        <main ref="main" App>
          <ToastContainer />
          <section className="section section-shaped section-lg">
            <Container className="pt-lg-sm pt-2">
              <Row className="justify-content-center">
                <Col lg="7">
                  <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-white pb-2 pt-3">
                      <div className=" pb-2">
                        <span style={{ fontSize: "30px" }}>
                          {" "}
                          Register As Vendor{" "}
                        </span>
                      </div>
                      <div className="pb-1">
                        <p style={{ fontSize: "20px" }}>
                          {" "}
                          Create a new account{" "}
                        </p>
                      </div>
                    </CardHeader>

                    <CardBody
                      style={{ backgroundColor: "White" }}
                      className="px-5 py-5"
                    >
                      <Form role="form" autoComplete="off">
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="firstName"
                                  onChange={this.onInputChange}
                                  placeholder="First Name"
                                  type="text"
                                  value={this.state.firstName}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="lastName"
                                  onChange={this.onInputChange}
                                  placeholder="Last Name"
                                  type="text"
                                  value={this.state.lastName}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <Input
                              id="username"
                              onChange={this.onUsernameChange}
                              onBlur={e => this.checkUsernameAvailability(e)}
                              placeholder="User Name"
                              type="text"
                              value={this.state.username}
                              invalid={usernameValidate === true ? false : true}
                              required
                            />
                            <FormFeedback>
                              {this.state.usernameFeadback}
                            </FormFeedback>
                          </InputGroup>
                        </FormGroup>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  value={this.state.password}
                                  id="password"
                                  onChange={e =>
                                    this.onPasswordChange(
                                      e,
                                      this.state.cPassword
                                    )
                                  }
                                  placeholder="Password"
                                  type="text"
                                  onKeyDown={e =>
                                    (e.currentTarget.type = "password")
                                  }
                                  autoComplete={
                                    this.state.password === null
                                      ? ""
                                      : this.state.password
                                  }
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="cPassword"
                                  onChange={e =>
                                    this.onPasswordChange(
                                      e,
                                      this.state.password
                                    )
                                  }
                                  placeholder="Confirm Password"
                                  type="text"
                                  onFocus={e =>
                                    (e.currentTarget.type = "password")
                                  }
                                  required
                                  invalid={
                                    passwordValidate === true ? false : true
                                  }
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <NumberFormat
                                  className="form-control"
                                  id="phoneNum"
                                  onChange={this.onInputChange}
                                  placeholder="Phone No"
                                  type="tel"
                                  invalid={
                                    phoneValidated === true ? false : true
                                  }
                                  value={this.state.phoneNum}
                                  format="(###) ###-####"
                                />{" "}
                              </InputGroup>
                            </FormGroup>
                          </Col>{" "}
                          <Col md={6}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="email"
                                  onChange={e => this.onEmailChange(e)}
                                  placeholder="Email (optional)"
                                  type="text"
                                  value={this.state.email}
                                  invalid={
                                    emailValidate === true ? false : true
                                  }
                                  onFocus={e =>
                                    (e.currentTarget.type = "email")
                                  }
                                  autoComplete={
                                    this.state.email === null
                                      ? ""
                                      : this.state.email
                                  }
                                  required
                                />
                                <FormFeedback>
                                  {this.state.emailFeadback}
                                </FormFeedback>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row form>
                          <Col md={12}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Autocomplete
                                  style={{
                                    padding: 6,
                                    width: "100%"
                                  }}
                                  id="address"
                                  value={this.state.address}
                                  onChange={this.onInputChange}
                                  type="text"
                                  placeholder="Street address"
                                  onPlaceSelected={place => {
                                    let stateObj = {};
                                    var componentForm = {
                                      street_number: "short_name",
                                      route: "long_name",
                                      locality: "long_name",
                                      administrative_area_level_1: "short_name",
                                      country: "long_name",
                                      postal_code: "short_name"
                                    };
                                    let address = place.address_components;
                                    address !== undefined &&
                                      address.forEach(item => {
                                        if (componentForm[item.types[0]]) {
                                          if (item.types[0] === "locality")
                                            stateObj.city = item.long_name;

                                          if (
                                            item.types[0] ===
                                            "administrative_area_level_1"
                                          )
                                            stateObj.state = item.long_name;
                                          if (item.types[0] === "postal_code")
                                            stateObj.zipCode = item.long_name;
                                        }
                                      });
                                    stateObj.address = place.formatted_address;
                                    stateObj.lat = place.geometry.location.lat();
                                    stateObj.lng = place.geometry.location.lng();
                                    this.setState(stateObj);
                                  }}
                                  types={["address"]}
                                  componentRestrictions={{ country: "us" }}
                                  fields={[
                                    "geometry",
                                    "formatted_address",
                                    "address_components"
                                  ]}
                                />
                                <div style={{ fontSize: "x-small" }}>
                                  Please use Google auto suggest to exactly pin
                                  point your location on our app maps.
                                </div>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="city"
                                  onChange={this.onInputChange}
                                  placeholder="City"
                                  type="text"
                                  required
                                  value={this.state.city}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="state"
                                  onChange={this.onInputChange}
                                  placeholder="State"
                                  type="text"
                                  required
                                  value={this.state.state}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="zipCode"
                                  placeholder="Zip Code"
                                  type="number"
                                  onChange={this.onInputChange}
                                  required
                                  value={this.state.zipCode}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row className="my-4">
                          <Col xs="12">
                            <div className="custom-control custom-control-alternative custom-checkbox">
                              <input
                                className="custom-control-input"
                                id="cbRegister"
                                type="checkbox"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="cbRegister"
                              ></label>

                              <span>
                                I agree with the{" "}
                                <a
                                  href="#pablo"
                                  onClick={e => e.preventDefault()}
                                >
                                  Privacy Policy
                                </a>
                              </span>
                            </div>
                          </Col>
                        </Row>
                        <div className="text-center">
                          <Row lg="12" className="px-3 ">
                            <Col>
                              <Button
                                className=" btn-lg mt-2"
                                color="primary"
                                type="button"
                                onClick={e => this.handleSubmit(e)}
                                name="submit"
                                tabIndex="-1"
                              >
                                Create account
                              </Button>
                            </Col>
                          </Row>
                        </div>

                        <div className="row mb-2">
                          {" "}
                          <span className="col-md-4 col-sm-4 col-xs-4"></span>
                          <span className="col-md-2 col-sm-2 col-xs-2"></span>
                          <span className="col-md-4 col-sm-4 col-xs-4">
                            <Button
                              className="bg-transparent text-info"
                              to="/login-page"
                              tag={Link}
                              color=""
                            >
                              {" "}
                              Already have an account?Sign in
                            </Button>
                          </span>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}

export default TireVendorRegForm;



// WEBPACK FOOTER //
// ./src/pages/RegVendor.js